import Config from 'react-native-config';

export const baseUrl = Config.API_URL;
export const baseUrlAgentSystem = Config.API_URL_AGENT_SYSTEM;
export const basePdfUrl = Config.BASE_PDF_URL;

export const api = {
  auth: {
    login: 'login',
    register: 'register',
    config: 'vars',
    updateUser: 'users/update',
    forgotPassword: 'password/forgot',
    resetPassword: 'password/reset',
    resendVerification: 'auth/resend-verification',
    logout: 'logout',
  },
  news: {
    newsDetails: 'news',
    recommendationsDetails: 'recommendations',
    drugDetails: 'drugs',
    diseasesDetails: 'disease',
    publishers: 'publishers/search',
    sharedNews: 'share',
    topics: 'topics',
  },
  content: {
    changePassword: 'user/change-password',
    tabFilters: 'tabs/filters',
    news: 'news',
    recommendations: 'recommendations',
    specialities: 'specialties',
  },
  ehr: {
    forms: 'forms',
    patients: 'patients',
    patientReports: 'patient-forms',
  },
  qna: {
    ask: 'ask',
    threads: 'threads',
    cases: 'cases',
    chats: 'chats',
    chatMessages: 'messages',
    categories: 'categories',
    devMessages: 'dev_message',
    addFavorite: 'favorite',
    removeFavorite: 'favorite/delete',
    removeChat: 'threads',
    share: 'share',
    publicChat: 'share',
  },
  summaries: {
    getById: 'summaries/',
    getByDateRange: 'summaries/date-range',
  },
  predictions: {
    getById: 'predicts/',
    getByDateRange: 'predicts/date-range',
  },
  analysis: {
    getById: 'analysis/',
    getByDateRange: 'analysis/date-range',
  },
  translate: {
    googleTranslate: 'api/google-translate',
  },
  tabs: {
    getAll: `${baseUrl}api/tabs`,
  },
};
